<template>
  <button
    :class="css"
    :title="title"
    :disabled="isSubmitting || disabled"
    @click="onClick"
  >
    <i v-if="icon && !isSubmitting" :class="icon" aria-hidden="true"></i>
    <i v-if="isSubmitting" class="fad fa-spinner-third fa-spin"></i>
    <span>
      {{text}}
    </span>
  </button>
</template>
<script>
export default {
  name: 'AppBtnSubmit',
  props: {
    isSubmitting: {
      type: Boolean,
      default() {
        return false;
      },
    },
    disabled: {
      type: Boolean,
      default() {
        return false;
      }
    },
    icon: {
      type: String,
      default() {
        return '';
      },
    },
    css: {
      type: String,
      default() {
        return 'btn btn-primary';
      },
    },
    text: {
      type: String,
      default() {
        return '';
      },
    },
    title: {
      type: String,
      default() {
        return '';
      },
    },
  },
  methods: {
    onClick($event) {
      this.$emit('on-click', $event);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/app-button/index.vue